// extracted by mini-css-extract-plugin
module.exports = {"iconPreview":"Icon_iconPreview__344i8","iconWrapper":"Icon_iconWrapper__1zzn1","tooltip":"Icon_tooltip__3hX5Q"};